<script setup lang="ts">
import { drawActions } from "@/action/drawActions";
import { action } from "@/components/action/action";
import IconButton from "@/components/ui/IconButton/IconButton.vue";
</script>

<template>
  <IconButton v-bind="action(drawActions.removeShape)" />
</template>
